import { EvideTableColumn, EvideTableColumnComponent, EvideTableColumnType } from "../common/common.model";

export interface INotificationEventEndpointFirebaseHttpResponse {
    notificationEventEndPointId: number;
    notificationEventId: number;
    fireBaseBody: string;
    fireBaseTitle: string;
    useDefaultFireBaseSettings: boolean;
    fireBaseServerKey: string;
    fireBaseClickActionUrl: string;
    fireBaseIconUrl: string;
    fireBaseSenderId: string;
}

export class NotificationEventEndpointFirebase {
    constructor(
        public notificationEventEndPointId: number,
        public notificationEventId: number,
        public fireBaseBody: string,
        public fireBaseTitle: string,
        public useDefaultFireBaseSettings: boolean,
        public fireBaseServerKey: string,
        public fireBaseClickActionUrl: string,
        public fireBaseIconUrl: string,
        public fireBaseSenderId: string
    ) { }

    public static adapt(data: INotificationEventEndpointFirebaseHttpResponse) {
        return new this(
            data.notificationEventEndPointId,
            data.notificationEventId,
            data.fireBaseBody,
            data.fireBaseTitle,
            data.useDefaultFireBaseSettings,
            data.fireBaseServerKey,
            data.fireBaseClickActionUrl,
            data.fireBaseIconUrl,
            data.fireBaseSenderId
        );
    }

    public static createBlank(notificationEventId: number) {
        return new this(0, notificationEventId, '', '', true, '', '', '', '');
    }
}

export const NotificationEventEndpointFirebaseColumns: Readonly<EvideTableColumn[]> = [
    {
        key: 'fireBaseBody',
        type: EvideTableColumnType.Text,
        compType: EvideTableColumnComponent.Editor,
        isFormField: true,
        isFormEditableField: true,
        title: 'Body',
        displayValue: true,
        required: true,
        required_error: 'Body is Required'
    },
    {
        key: 'fireBaseTitle',
        type: EvideTableColumnType.Text,
        compType: EvideTableColumnComponent.Editor,
        isFormField: true,
        isFormEditableField: true,
        title: 'Title',
        displayValue: true,
        required: true,
        required_error: 'Title is Required'
    },
    {
        key: 'fireBaseClickActionUrl',
        type: EvideTableColumnType.Number,
        compType: EvideTableColumnComponent.Dropdown,
        isFormField: true,
        isFormEditableField: true,
        title: 'Click Action Url',
        hideInList: true,
        required: false,
        placeholder: 'Please Select Click Action Url',
        required_error: 'Click Action Url is Required',
        sortable: true
    },
    {
        key: 'useDefaultFireBaseSettings',
        type: EvideTableColumnType.Checkbox,
        compType: EvideTableColumnComponent.Input,
        isFormField: true,
        isFormEditableField: true,
        title: 'Use Default Firebase Settings',
        displayValue: true,
        required: false
    },
    {
        key: 'fireBaseServerKey',
        type: EvideTableColumnType.Text,
        compType: EvideTableColumnComponent.Input,
        isFormField: true,
        isFormEditableField: true,
        title: 'Server Key',
        displayValue: true,
        required: false,
        displayDynamicInput: true
    },
    {
        key: 'fireBaseIconUrl',
        type: EvideTableColumnType.String,
        compType: EvideTableColumnComponent.Input,
        isFormField: true,
        isFormEditableField: true,
        title: 'Icon Url',
        displayValue: true,
        required: false,
        displayDynamicInput: true
    },
    {
        key: 'fireBaseSenderId',
        type: EvideTableColumnType.String,
        compType: EvideTableColumnComponent.Input,
        isFormField: true,
        isFormEditableField: true,
        title: 'Sender Id',
        displayValue: true,
        required: false,
        displayDynamicInput: true
    }
];